// extracted by mini-css-extract-plugin
export default {"violation":"violationStats_violation__SHx-i"};